export default __webpack_public_path__ + "static/media/Heart of Atali.8ea6a610.jpg";